import angular from 'angular'

import InvitationHandlersRepository from './invitation-handlers.repo';

export default angular.module('rb.invitations', [ ])
  .service('InvitationHandlersRepository', InvitationHandlersRepository)
